

import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Tab,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import Navbar from "../../../Navbar";
import Footer from "../../../Footer";
import ServiceDetails from "./ServiceDetails";
import TotalEnquiries from "./TotalEnquiries";
import TotalServices from "./TotalServices";
import Cancellations from "./Cancellations";
import Feedback from "./Feedback";
import ProfAvailable from "./ProfAvailable";
import { API_URL } from "../../Config/api";

const HDLayout = ({
  tabValue,
  handleTabChange,
  hospitalList,
  selectedHospital,
  handleHospitalChange,
  assignData,
  allServices,
  services,
  dashboardCounts,
}) => {
  return (
    <Grid container spacing={1} sx={{ mt: 0,bgcolor:'#F6F6F6' }}>
      <Grid item xs={12}>
        <Grid container alignItems="center" spacing={2}>
          <Grid
            item
            xs={12}
            md={7}
            sm={6}
            lg={3.5}
            sx={{
              maxWidth: 250,
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <Box
              sx={{
                background: "#f1f1f1",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                px: 2,
              }}
            >
              <TabList
                onChange={handleTabChange}
                value={tabValue}
                sx={{ width: "100%" }}
                TabIndicatorProps={{
                  style: {
                    background: "#69A5EB",
                    height: "36px",
                    marginBottom: "8px",
                    borderRadius: "10px",
                  },
                }}
              >
                <Tab
                  label="Today"
                  value="1"
                  sx={{
                    fontSize: "15px",
                    textTransform: "capitalize",
                    color: "#000000", // Default text color
                    "&.Mui-selected": {
                      color: "#000000", // Selected tab text
                      // backgroundColor: "#69A5EB", // Match TabIndicator
                      borderRadius: "10px",
                      zIndex: 1,
                    },
                  }}
                />
                <Tab
                  label="This Month"
                  value="2"
                  sx={{
                    fontSize: "15px",
                    textTransform: "capitalize",
                    color: "#000000", // Default text color
                    "&.Mui-selected": {
                      color: "#000000", // Selected tab text
                      borderRadius: "10px",
                      zIndex: 1,
                    },
                  }}
                />
                <Tab
                  label="Last Month"
                  value="3"
                  sx={{
                    fontSize: "15px",
                    textTransform: "capitalize",
                    color: "#000000", // Default text color
                    "&.Mui-selected": {
                      color: "#000000", // Selected tab text
                      borderRadius: "10px",
                      zIndex: 1,
                    },
                  }}
                />
              </TabList>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            lg={8}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <FormControl size="small" sx={{ minWidth: 270 }}>
              <InputLabel id="hospital-label">Hospital</InputLabel>
              <Select
                value={selectedHospital}
                label="Hospital"
                onChange={handleHospitalChange}
                labelId="hospital-label"
              >
                <MenuItem value="">All Hospitals</MenuItem>
                {hospitalList.map((hosp) => (
                  <MenuItem
                    key={hosp.id || hosp.hosp_id}
                    value={String(hosp.id || hosp.hosp_id)}
                  >
                    {hosp.hospital_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>

      {/* Data cards */}
      <Grid item xs={12} md={4}>
        <ServiceDetails tabValue={tabValue} allServices={allServices} />
      </Grid>

      <Grid item xs={12} md={8}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={5}>
            <TotalServices services={services} tabValue={tabValue} />
          </Grid>
          <Grid item xs={12} sm={6} md={7}>
            <TotalEnquiries
              tabValue={tabValue}
              enquiryData={dashboardCounts.enquiry}
            />
          </Grid>
          <Grid item xs={12} sm={4.5} md={4}>
            <Cancellations
              tabValue={tabValue}
              cancellationData={dashboardCounts.cancellation}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4.5}>
            <ProfAvailable tabValue={tabValue} assignData={assignData} />
          </Grid>
          <Grid item xs={12} sm={3.5} md={3.5}>
            <Feedback
              tabValue={tabValue}
              feedbackData={dashboardCounts.feedback}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const HD_Dashboard = () => {
  // const port = process.env.REACT_APP_API_KEY;
  const accessToken = localStorage.getItem("token");

  const [tabValue, setTabValue] = useState("1");
  const [hospitalList, setHospitalList] = useState([]);
  const [selectedHospital, setSelectedHospital] = useState(""); // default no filter

  const [assignData, setAssignData] = useState({});
  const [services, setServices] = useState({});
  // const [allServices, setAllServices] = useState({});
  const [dashboardCounts, setDashboardCounts] = useState({
    enquiry: {},
    feedback: {},
    cancellation: {},
  });

  // 🟢 Fetch hospital list
  useEffect(() => {
    fetch(`${API_URL}/web/agg_hhc_hospitals_api_web_form`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
      .then((res) => res.json())
      .then((data) => Array.isArray(data) && setHospitalList(data))
      .catch((err) => console.error("Hospital list fetch error:", err));
  }, [API_URL, accessToken]);

  // 🔹 Universal fetch functions
  const fetchAssignUnassignCount = (hospId) => {
    const url = hospId
      ? `${API_URL}/web/professional-count/?hosp_id=${hospId}`
      : `${API_URL}/web/professional-count/`;

    fetch(url, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((res) => res.json())
      .then(setAssignData)
      .catch((err) => console.error("Professional count error:", err));
  };

  const fetchServicesCount = (hospId) => {
    const url = hospId
      ? `${API_URL}/web/TotalServicesOngoingPendingCompleted/?hosp_id=${hospId}`
      : `${API_URL}/web/TotalServicesOngoingPendingCompleted/`;

    fetch(url, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((res) => res.json())
      .then(setServices)
      .catch((err) => console.error("Services count error:", err));
  };

  // Service details state
  const [allServices, setAllServices] = useState({
    services: [],
    complete_service: { today: [], this_month: [], till_date: [] },
    ongoing_service: { today: [], this_month: [], till_date: [] },
    pending_service: { today: [], this_month: [], till_date: [] },
  });

  // Fetch service details
  const fetchAllServices = (hospitalId) => {
    const url =
      hospitalId && hospitalId !== "all"
        ? `${API_URL}/web/Details_of_ServicesOngoingPendingCompleted/?hosp_id=${hospitalId}`
        : `${API_URL}/web/Details_of_ServicesOngoingPendingCompleted/`;

    fetch(url, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((res) => res.json())
      .then((data) => {
        if (!Array.isArray(data)) return;

        const services = data.map((service) => service.srv_name);

        const complete_service = {
          today: data.map((s) => s.data.total_completed_today),
          this_month: data.map((s) => s.data.total_completed_this_month),
          till_date: data.map((s) => s.data.total_completed_till_date),
        };

        const ongoing_service = {
          today: data.map((s) => s.data.total_ongoing_today),
          this_month: data.map((s) => s.data.total_ongoing_this_month),
          till_date: data.map((s) => s.data.total_ongoing_till_date),
        };

        const pending_service = {
          today: data.map((s) => s.data.total_pending_today),
          this_month: data.map((s) => s.data.total_pending_this_month),
          till_date: data.map((s) => s.data.total_pending_till_date),
        };

        setAllServices({
          services,
          complete_service,
          ongoing_service,
          pending_service,
        });
      })
      .catch((err) => console.error("Error fetching service details:", err));
  };

  // Fetch on dashboard load for ALL hospitals
  useEffect(() => {
    fetchAllServices("all");
  }, []);

  // Fetch when user selects hospital or changes tab
  useEffect(() => {
    fetchAllServices(selectedHospital); // selectedHospital can be 'all' or a specific hospital ID
  }, [selectedHospital, tabValue]);

  const fetchDashboardCounts = (tab, hospId) => {
    const url = hospId
      ? `${API_URL}/web/Dashboard_enquiry_cancellation_feedback_counts/${tab}/${hospId}/`
      : `${API_URL}/web/Dashboard_enquiry_cancellation_feedback_counts/${tab}/`;

    fetch(url, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((res) => res.json())
      .then(setDashboardCounts)
      .catch((err) => console.error("Dashboard counts error:", err));
  };

  // 🟢 On first load → show full (no filter)
  useEffect(() => {
    fetchAssignUnassignCount("");
    fetchServicesCount("");
    fetchAllServices("");
    fetchDashboardCounts(tabValue, "");
  }, []);

  // 🟢 When tab or hospital changes
  useEffect(() => {
    fetchAssignUnassignCount(selectedHospital);
    fetchServicesCount(selectedHospital);
    fetchAllServices(selectedHospital);
    fetchDashboardCounts(tabValue, selectedHospital);
  }, [selectedHospital, tabValue]);

  const handleTabChange = (e, newValue) => setTabValue(newValue);
  const handleHospitalChange = (e) => setSelectedHospital(e.target.value);

  return (
    <>
      <Navbar />
      <Box sx={{ flexGrow: 1, mt: 11, mb: 2, width: "100%" }}>
        <TabContext value={tabValue}>
          <TabPanel value="1">
            <HDLayout
              tabValue={tabValue}
              handleTabChange={handleTabChange}
              hospitalList={hospitalList}
              selectedHospital={selectedHospital}
              handleHospitalChange={handleHospitalChange}
              assignData={assignData}
              allServices={allServices}
              services={services}
              dashboardCounts={dashboardCounts}
            />
          </TabPanel>
          <TabPanel value="2">
            <HDLayout
              tabValue={tabValue}
              handleTabChange={handleTabChange}
              hospitalList={hospitalList}
              selectedHospital={selectedHospital}
              handleHospitalChange={handleHospitalChange}
              assignData={assignData}
              allServices={allServices}
              services={services}
              dashboardCounts={dashboardCounts}
            />
          </TabPanel>
          <TabPanel value="3">
            <HDLayout
              tabValue={tabValue}
              handleTabChange={handleTabChange}
              hospitalList={hospitalList}
              selectedHospital={selectedHospital}
              handleHospitalChange={handleHospitalChange}
              assignData={assignData}
              allServices={allServices}
              services={services}
              dashboardCounts={dashboardCounts}
            />
          </TabPanel>
        </TabContext>
      </Box>
      <Footer />
    </>
  );
};

export default HD_Dashboard;
